import { Fragment, useEffect } from "react";
import { Outlet } from "react-router-dom";
import { observer } from "mobx-react-lite";
import AppFrame from "./AppFrame";
import { useStore } from "../stores/store";
import { Loading } from "@shopify/polaris";
import LoginPage from "../../features/users/LoginPage";
import SettingsPage from "../../features/settings/SettingsPage";
import LandingPage from "../../features/home/LandingPage";

const App = () => {
  const { commonStore, userStore } = useStore();

  useEffect(() => {
    const loadUser = async () => {
      if (!commonStore.token) {
        commonStore.setAppLoaded();
        return;
      }

      await userStore.getUser();

      const params = new URLSearchParams(window.location.search);
      const urlShop = params.get("shop");
      if (urlShop && userStore.user?.shopDomain && urlShop !== userStore.user.shopDomain) {
        userStore.logout();
      }

      commonStore.setAppLoaded();
    };

    loadUser();
  }, [commonStore, userStore]);

  if (!commonStore.appLoaded) return (<Fragment><AppFrame><div style={{ height: '100px' }}><Loading /></div></AppFrame></Fragment>)

  if (!userStore.isLoggedIn) {
    if (window.location.pathname === '/login') {
      return (<Fragment><LoginPage /></Fragment>);
    }

    return (
      <Fragment>
        <LandingPage />
      </Fragment>
    );
  }

  return (
    <AppFrame>
      {window.location.pathname === '/' ? <SettingsPage /> : (
        <Outlet />
      )}
    </AppFrame>
  )

};

export default observer(App);
